import React from 'react';
import { Url, URLS } from '@wix/da-url';
export class LogoutItem extends React.Component {
    render() {
        const { formRef, token, label } = this.props;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("form", {
            id: "logout-form",
            ref: formRef,
            action: Url.buildFromPath(URLS.LOGOUT),
            method: "POST"
        }, /*#__PURE__*/ React.createElement("input", {
            type: "hidden",
            name: "validate_token",
            value: token,
            autoComplete: "off"
        })), label);
    }
}
export default LogoutItem;

//# sourceMappingURL=LogoutItem.js.map